export default {
  methods: {
    redirectRoute(name, params = {}, query = {}, oldQuery = {}, localStorageName = "") {
      this.supportLocalStorage(oldQuery, localStorageName)
      this.$router.push({ name: name, params: params, query: query});
    },
    redirectRouteTargetBlank(name, params = {}, query = {}, oldQuery = {}, localStorageName = "") {
      this.supportLocalStorage(oldQuery, localStorageName)
      const route = this.$router.resolve({
        name: name,
        params: params,
        query: query,
      });
      window.open(route.href, "_blank");
    },
    supportLocalStorage(object, name) {
      if (Object.keys(object).length > 0) {
        localStorage[name] = JSON.stringify(object)
      } else {
        localStorage.removeItem(name)
      }
    }
  }
};
